import { GetCouponResponse, RawCoupon } from '@server/schemas'
import dayjs from 'dayjs'

export const sortRawCoupons = (coupons: RawCoupon[]) => {
  if (!coupons) {
    return coupons
  }

  // 96시간 전 기준 계산
  const threshold = dayjs().subtract(96, 'hour')

  return [...coupons].sort((coupon1, coupon2) => {
    // 96시간 안에 있는 경우 우선 정렬
    const coupon1UseEnd = dayjs(coupon1.utc_use_end)
    const coupon2UseEnd = dayjs(coupon2.utc_use_end)
    const coupon1Within96Hours = coupon1UseEnd.isAfter(threshold)
    const coupon2Within96Hours = coupon2UseEnd.isAfter(threshold)

    // 둘 다 96시간 이내에 포함된 경우 UtcUseEnd 기준으로 오름차순 정렬
    if (coupon1Within96Hours && coupon2Within96Hours) {
      if (coupon1.utc_use_end === coupon2.utc_use_end) {
        // 기간만료일이 동일하다면 최신 등록 순
        return dayjs(coupon2.utc_created_at).valueOf() - dayjs(coupon1.utc_created_at).valueOf()
      } else {
        return coupon1UseEnd.valueOf() - coupon2UseEnd.valueOf()
      }
    }

    // 하나만 96시간 이내에 포함된 경우 포함된 것을 우선 정렬
    if (coupon1Within96Hours) {
      return -1 // coupon1이 앞에 위치
    } else if (coupon2Within96Hours) {
      return 1 // c2가 앞에 위치
    }

    // 동일한 조건이라면 getUtcCreatedAt 기준 내림차순 정렬
    return dayjs(coupon2.utc_created_at).valueOf() - dayjs(coupon1.utc_created_at).valueOf()
  })
}

export const sortAvailableCoupons = (coupons: GetCouponResponse[]) => {
  if (!coupons) {
    return coupons
  }

  // 96시간 전 기준 계산
  const threshold = dayjs().subtract(96, 'hour')

  return [...coupons].sort((coupon1, coupon2) => {
    // 96시간 안에 있는 경우 우선 정렬
    const coupon1UseEnd = dayjs(coupon1.utcUseEnd)
    const coupon2UseEnd = dayjs(coupon2.utcUseEnd)
    const coupon1Within96Hours = coupon1UseEnd.isAfter(threshold)
    const coupon2Within96Hours = coupon2UseEnd.isAfter(threshold)

    // 둘 다 96시간 이내에 포함된 경우 UtcUseEnd 기준으로 오름차순 정렬
    if (coupon1Within96Hours && coupon2Within96Hours) {
      if (coupon1.utcUseEnd === coupon2.utcUseEnd) {
        // 기간만료일이 동일하다면 최신 등록 순
        return dayjs(coupon2.utcCreatedAt).valueOf() - dayjs(coupon1.utcCreatedAt).valueOf()
      } else {
        return coupon1UseEnd.valueOf() - coupon2UseEnd.valueOf()
      }
    }

    // 하나만 96시간 이내에 포함된 경우 포함된 것을 우선 정렬
    if (coupon1Within96Hours) {
      return -1 // coupon1이 앞에 위치
    } else if (coupon2Within96Hours) {
      return 1 // c2가 앞에 위치
    }

    // 동일한 조건이라면 getUtcCreatedAt 기준 내림차순 정렬
    return dayjs(coupon2.utcCreatedAt).valueOf() - dayjs(coupon1.utcCreatedAt).valueOf()
  })
}
